import Vue from "vue";
import VueRouter from "vue-router";
import Projects from "../views/Projects.vue";
import ShowProject from "../views/ShowProject.vue";
import Contact from "../views/Contact.vue";
import Privacy from "../views/Privacy.vue";
import CurriculumVitae from "../views/CurriculumVitae.vue";
import Imprint from "../views/Imprint.vue";
import P001 from "../project_pages/P001.vue";
import P002 from "../project_pages/P002.vue";
import P003 from "../project_pages/P003.vue";
import P004 from "../project_pages/P004.vue";
import P005 from "../project_pages/P005.vue";
import P006 from "../project_pages/P006.vue";
import P007 from "../project_pages/P007.vue";
import P008 from "../project_pages/P008.vue";
import P009 from "../project_pages/P009.vue";
import P010 from "../project_pages/P010.vue";
import P011 from "../project_pages/P011.vue";
import P012 from "../project_pages/P012.vue";
import P013 from "../project_pages/P013.vue";
import P014 from "../project_pages/P014.vue";
import P015 from "../project_pages/P015.vue";
import P016 from "../project_pages/P016.vue";
import P017 from "../project_pages/P017.vue";
import P018 from "../project_pages/P018.vue";
import P019 from "../project_pages/P019.vue";
import P020 from "../project_pages/P020.vue";
import P021 from "../project_pages/P021.vue";
import P022 from "../project_pages/P022.vue";
import P023 from "../project_pages/P023.vue";
import P024 from "../project_pages/P024.vue";
import P025 from "../project_pages/P025.vue";
import P026 from "../project_pages/P026.vue";
import P027 from "../project_pages/P027.vue";
import P028 from "../project_pages/P028.vue";
import P029 from "../project_pages/P029.vue";
import P030 from "../project_pages/P030.vue";
import P031 from "../project_pages/P031.vue";
import P032 from "../project_pages/P032.vue";
import P033 from "../project_pages/P033.vue";
import P034 from "../project_pages/P034.vue";
import P035 from "../project_pages/P035.vue";
// import P036 from "../project_pages/P036.vue";
// import P037 from "../project_pages/P037.vue";
// import P038 from "../project_pages/P038.vue";
// import P039 from "../project_pages/P039.vue";
// import P040 from "../project_pages/P040.vue";
// import P041 from "../project_pages/P041.vue";
// import P042 from "../project_pages/P042.vue";
// import P043 from "../project_pages/P043.vue";
// import P044 from "../project_pages/P044.vue";
// import P045 from "../project_pages/P045.vue";
// import P046 from "../project_pages/P046.vue";
// import P047 from "../project_pages/P047.vue";
// import P048 from "../project_pages/P048.vue";
// import P049 from "../project_pages/P049.vue";
// import P050 from "../project_pages/P050.vue";
// import P051 from "../project_pages/P051.vue";
// import P052 from "../project_pages/P052.vue";
// import P053 from "../project_pages/P053.vue";
// import P054 from "../project_pages/P054.vue";
// import P055 from "../project_pages/P055.vue";
// import P056 from "../project_pages/P056.vue";
// import P057 from "../project_pages/P057.vue";
// import P058 from "../project_pages/P058.vue";
// import P059 from "../project_pages/P059.vue";
// import P060 from "../project_pages/P060.vue";
// import P061 from "../project_pages/P061.vue";
// import P062 from "../project_pages/P062.vue";
// import P063 from "../project_pages/P063.vue";
// import P064 from "../project_pages/P064.vue";
// import P065 from "../project_pages/P065.vue";
// import P066 from "../project_pages/P066.vue";
// import P067 from "../project_pages/P067.vue";
// import P068 from "../project_pages/P068.vue";
// import P069 from "../project_pages/P069.vue";
// import P070 from "../project_pages/P070.vue";
// import P071 from "../project_pages/P071.vue";
// import P072 from "../project_pages/P072.vue";
// import P073 from "../project_pages/P073.vue";
// import P074 from "../project_pages/P074.vue";
// import P075 from "../project_pages/P075.vue";
// import P076 from "../project_pages/P076.vue";
// import P077 from "../project_pages/P077.vue";
// import P078 from "../project_pages/P078.vue";
// import P079 from "../project_pages/P079.vue";
// import P080 from "../project_pages/P080.vue";
// import P081 from "../project_pages/P081.vue";
// import P082 from "../project_pages/P082.vue";
// import P083 from "../project_pages/P083.vue";
// import P084 from "../project_pages/P084.vue";
// import P085 from "../project_pages/P085.vue";
// import P086 from "../project_pages/P086.vue";
// import P087 from "../project_pages/P087.vue";
// import P088 from "../project_pages/P088.vue";
// import P089 from "../project_pages/P089.vue";
// import P090 from "../project_pages/P090.vue";
// import P091 from "../project_pages/P091.vue";
// import P092 from "../project_pages/P092.vue";
// import P093 from "../project_pages/P093.vue";
// import P094 from "../project_pages/P094.vue";
// import P095 from "../project_pages/P095.vue";
// import P096 from "../project_pages/P096.vue";
// import P097 from "../project_pages/P097.vue";
// import P098 from "../project_pages/P098.vue";
// import P099 from "../project_pages/P099.vue";

Vue.use( VueRouter );

const routes = [ {
    path: "/",
    name: "Projects",
    component: Projects,
},
// {
//     path: "/:isGerman",
//     name: "Projects",
//     component: Projects,
//     props: true,
// },
// {
//     path: "/about",
//     name: "About",
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () =>
//         import ( /* webpackChunkName: "about" */ "../views/About.vue"),
// },
{
    path: "/contact",
    name: "Contact",
    component: Contact,
},
{
    path: "/curriculum-vitae",
    name: "CurriculumVitae",
    component: CurriculumVitae,
},
{
    path: "/imprint",
    name: "Imprint",
    component: Imprint,
},
{
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
},
{
    path: "/show-project/:title",
    component: ShowProject,
    children: [ {
        path: "p001",
        component: P001,
    },
    {
        path: "p002",
        component: P002,
    },
    {
        path: "p003",
        component: P003,
    },
    {
        path: "p004",
        component: P004,
    },
    {
        path: "p005",
        component: P005,
    },
    {
        path: "p006",
        component: P006,
    },
    {
        path: "p007",
        component: P007,
    },
    {
        path: "p008",
        component: P008,
    },
    {
        path: "p009",
        component: P009,
    },
    {
        path: "p010",
        component: P010,
    },
    {
        path: "p011",
        component: P011,
    },
    {
        path: "p012",
        component: P012,
    },
    {
        path: "p013",
        component: P013,
    },
    {
        path: "p014",
        component: P014,
    },
    {
        path: "p015",
        component: P015,
    },
    {
        path: "p016",
        component: P016,
    },
    {
        path: "p017",
        component: P017,
    },
    {
        path: "p018",
        component: P018,
    },
    {
        path: "p019",
        component: P019,
    },
    {
        path: "p020",
        component: P020,
    },
    {
        path: "p021",
        component: P021,
    },
    {
        path: "p022",
        component: P022,
    },
    {
        path: "p023",
        component: P023,
    },
    {
        path: "p024",
        component: P024,
    },
    {
        path: "p025",
        component: P025,
    },
    {
        path: "p026",
        component: P026,
    },
    {
        path: "p027",
        component: P027,
    },
    {
        path: "p028",
        component: P028,
    },
    {
        path: "p029",
        component: P029,
    },
    {
        path: "p030",
        component: P030,
    },
    {
        path: "p031",
        component: P031,
    },
    {
        path: "p032",
        component: P032,
    },
    {
        path: "p033",
        component: P033,
    },
    {
        path: "p034",
        component: P034,
    },
    {
        path: "p035",
        component: P035,
    },
        // {
        //     path: "p036",
        //     component: P036,
        // },
        // {
        //     path: "p037",
        //     component: P037,
        // },
        // {
        //     path: "p038",
        //     component: P038,
        // },
        // {
        //     path: "p039",
        //     component: P039,
        // },
        // {
        //     path: "p040",
        //     component: P040,
        // },
        // {
        //     path: "p041",
        //     component: P041,
        // },
        // {
        //     path: "p042",
        //     component: P042,
        // },
        // {
        //     path: "p043",
        //     component: P043,
        // },
        // {
        //     path: "p044",
        //     component: P044,
        // },
        // {
        //     path: "p045",
        //     component: P045,
        // },
        // {
        //     path: "p046",
        //     component: P046,
        // },
        // {
        //     path: "p047",
        //     component: P047,
        // },
        // {
        //     path: "p048",
        //     component: P048,
        // },
        // {
        //     path: "p049",
        //     component: P049,
        // },
        // {
        //     path: "p050",
        //     component: P050,
        // },
        // {
        //     path: "p051",
        //     component: P051,
        // },
        // {
        //     path: "p052",
        //     component: P052,
        // },
        // {
        //     path: "p053",
        //     component: P053,
        // },
        // {
        //     path: "p054",
        //     component: P054,
        // },
        // {
        //     path: "p055",
        //     component: P055,
        // },
        // {
        //     path: "p056",
        //     component: P056,
        // },
        // {
        //     path: "p057",
        //     component: P057,
        // },
        // {
        //     path: "p058",
        //     component: P058,
        // },
        // {
        //     path: "p059",
        //     component: P059,
        // },
        // {
        //     path: "p060",
        //     component: P060,
        // },
        // {
        //     path: "p061",
        //     component: P061,
        // },
        // {
        //     path: "p062",
        //     component: P062,
        // },
        // {
        //     path: "p063",
        //     component: P063,
        // },
        // {
        //     path: "p064",
        //     component: P064,
        // },
        // {
        //     path: "p065",
        //     component: P065,
        // },
        // {
        //     path: "p066",
        //     component: P066,
        // },
        // {
        //     path: "p067",
        //     component: P067,
        // },
        // {
        //     path: "p068",
        //     component: P068,
        // },
        // {
        //     path: "p069",
        //     component: P069,
        // },
        // {
        //     path: "p070",
        //     component: P070,
        // },
        // {
        //     path: "p071",
        //     component: P071,
        // },
        // {
        //     path: "p072",
        //     component: P072,
        // },
        // {
        //     path: "p073",
        //     component: P073,
        // },
        // {
        //     path: "p074",
        //     component: P074,
        // },
        // {
        //     path: "p075",
        //     component: P075,
        // },
        // {
        //     path: "p076",
        //     component: P076,
        // },
        // {
        //     path: "p077",
        //     component: P077,
        // },
        // {
        //     path: "p078",
        //     component: P078,
        // },
        // {
        //     path: "p079",
        //     component: P079,
        // },
        // {
        //     path: "p080",
        //     component: P080,
        // },
        // {
        //     path: "p081",
        //     component: P081,
        // },
        // {
        //     path: "p082",
        //     component: P082,
        // },
        // {
        //     path: "p083",
        //     component: P083,
        // },
        // {
        //     path: "p084",
        //     component: P084,
        // },
        // {
        //     path: "p085",
        //     component: P085,
        // },
        // {
        //     path: "p086",
        //     component: P086,
        // },
        // {
        //     path: "p087",
        //     component: P087,
        // },
        // {
        //     path: "p088",
        //     component: P088,
        // },
        // {
        //     path: "p089",
        //     component: P089,
        // },
        // {
        //     path: "p090",
        //     component: P090,
        // },
        // {
        //     path: "p091",
        //     component: P091,
        // },
        // {
        //     path: "p092",
        //     component: P092,
        // },
        // {
        //     path: "p093",
        //     component: P093,
        // },
        // {
        //     path: "p094",
        //     component: P094,
        // },
        // {
        //     path: "p095",
        //     component: P095,
        // },
        // {
        //     path: "p096",
        //     component: P096,
        // },
        // {
        //     path: "p097",
        //     component: P097,
        // },
        // {
        //     path: "p098",
        //     component: P098,
        // },
        // {
        //     path: "p099",
        //     component: P099,
        // },
    ]
},
];

const router = new VueRouter( {
    routes,

    scrollBehavior ( to, from, savedPosition )
    {
        if ( savedPosition )
        {
            return savedPosition;

        } else
        {
            return { x: 0, y: 0 };
        }
    },
} );

export default router;